<template>
  <div class="header">
    <!-- 折叠按钮 -->
    <div class="collapse-btn" @click="collapseChage">
      <i class="el-icon-lx-home"></i>
    </div>
    <div class="logo">客服工作系统（{{ systemLabel }}）</div>
    <div class="header-right">
      <div class="header-user-con">
        <!-- 全屏显示 -->
        <div>
          <el-badge class="item" style="margin-right: 20px">
            <el-popover width="300" trigger="hover">
              <div>
                <!-- <p style="font-width: bold; font-size: 17px">个人中心</p> -->
                <!-- <p style="font-width: bold; font-size: 15px">一级通知</p>
                <div class="font-style" style="margin: 2px 0 2px 20px">
                  <span style="color: balck; font-size: 15px"
                    >您有<span style="color: red; font-width: bold">{{ getNotice.notice_level_1 }}</span
                    >条未读通知</span
                  ><button @click="viewNoticeDetails" class="link-Jump">查看详情</button>
                </div> -->
                <!-- <p style="font-width: bold; font-size: 15px">二级通知</p>
                <div style="margin: 2px 0 2px 20px">
                  <span style="color: balck; font-size: 15px"
                    >您有<span style="color: red; font-width: bold">{{ getNotice.notice_level_2 }}</span
                    >条未读通知</span
                  ><button @click="viewNoticeDetails" class="link-Jump">查看详情</button>
                </div> -->
                <!-- <p style ="font-width:bold;font-size:15px;">三级通知</p>
                <div style="margin:2px 0 2px 20px;"><span style="color:balck;font-size:15px">您有<span style = "color:red;font-width:bold">{{getNotice.notice_level_3}}</span>/条未读通知</span><button @click ="viewNoticeDetails" class="link-Jump">查看详情</button> </div> -->
                <p>任务交接</p>
                <div style="margin: 5px 0 0 20px">
                  <span style="color: balck; font-size: 15px"
                    >您有<span style="color: red; font-width: bold">{{ getNotice.mission }}</span
                    >条未读任务交接信息</span
                  ><button @click="viewTaskDetails" class="link-Jump">查看详情</button>
                </div>
              </div>
              <span slot="reference">个人中心</span>
            </el-popover>
          </el-badge>
        </div>

        <div class="btn-fullscreen" @click="handleFullScreen">
          <el-tooltip effect="dark" :content="fullscreen ? `取消全屏` : `全屏`" placement="bottom">
            <i class="el-icon-rank"></i>
          </el-tooltip>
        </div>

        <!-- 消息中心 -->
        <!-- <div class="btn-bell">
          <el-tooltip effect="dark" :content="message?`有${message}条未读消息`:`消息中心`" placement="bottom">
            <router-link to="/tabs">
              <i class="el-icon-bell"></i>
            </router-link>
          </el-tooltip>
          <span class="btn-bell-badge" v-if="message"></span>
        </div> -->
        <!-- 用户头像 -->
        <div class="user-avator">
          <img src="../../assets/img/img.jpg" />
        </div>
        <!-- 用户名下拉菜单 -->
        <el-dropdown class="user-name" trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            {{ username }}
            <i class="el-icon-caret-bottom"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <router-link to="setting-personal">
              <el-dropdown-item>个人中心</el-dropdown-item>
            </router-link>
            <el-dropdown-item divided command="loginout">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
    </div>
  </div>
</template>
<script>
import { logoutApi } from '@/api/login.js';
import { personalCenterApi, getNoticeMissionApi } from '@/api/personalCenter.js';
import { removeToken, removeName, removeRoles, getName } from '@/utils/localStorage.js';
import { isYuewanLocation } from '@/config';

import bus from '../common/bus';
export default {
  data() {
    return {
      collapse: false,
      fullscreen: false,
      name: 'admin',
      message: 2,
    };
  },
  computed: {
    username() {
      let username = getName();
      return username ? username : this.name;
    },
    systemLabel() {
      return isYuewanLocation() ? '悦玩' : '玩心';
    },
    getNotice() {
      let data = this.$store.state.notice;
      if (data.number == 0) {
        data.number = '';
      }
      return data;
    },
  },
  methods: {
    loginout() {
      logoutApi()
        .then((response) => {
          this.$message({
            message: '操作成功',
            type: 'success',
          });
          removeToken();
          removeName();
          removeRoles();
          this.$router.push({ path: '/login' });
          let item = {
            action: 'logout',
          };
          this.$store.commit('STAFF_SEDNWEBSOCKET', item);
          // this.$router.push({ path: "/login" });
        })
        .catch((error) => {
          console.log(error);
        });
    },
    // 用户名下拉菜单选择事件
    handleCommand(command) {
      if (command == 'loginout') {
        this.loginout();
        // localStorage.removeItem("ms_username");
        // this.$router.push("/login");
      }
    },
    // 侧边栏折叠
    collapseChage() {
      this.collapse = !this.collapse;
      bus.$emit('collapse', this.collapse);
    },
    // 全屏事件
    handleFullScreen() {
      let element = document.documentElement;
      if (this.fullscreen) {
        if (document.exitFullscreen) {
          document.exitFullscreen();
        } else if (document.webkitCancelFullScreen) {
          document.webkitCancelFullScreen();
        } else if (document.mozCancelFullScreen) {
          document.mozCancelFullScreen();
        } else if (document.msExitFullscreen) {
          document.msExitFullscreen();
        }
      } else {
        if (element.requestFullscreen) {
          element.requestFullscreen();
        } else if (element.webkitRequestFullScreen) {
          element.webkitRequestFullScreen();
        } else if (element.mozRequestFullScreen) {
          element.mozRequestFullScreen();
        } else if (element.msRequestFullscreen) {
          // IE11
          element.msRequestFullscreen();
        }
      }
      this.fullscreen = !this.fullscreen;
    },
    // 进入实时通知界面
    viewNoticeDetails() {
      this.$router.push({ path: '/customer-time_notice' });
    },
    // 进入任务交接界面
    viewTaskDetails() {
      this.$router.push({ path: '/customer-problem' });
    },
    personalCenter() {
      personalCenterApi()
        .then((response) => {
          let data = response.data.data;
          if (data.notice_level_3 != 0) {
            data.number = data.number - data.notice_level_3;
          }
          this.$store.commit('getNotice', data);
        })
        .catch((error) => {});
    },
    getNoticeMission() {
      setTimeout(() => {
        getNoticeMissionApi()
          .then((response) => {
            this.personalCenter();
          })
          .catch((error) => {});
      }, 2000);
    },
  },
  mounted() {
    if (document.body.clientWidth < 1500) {
      this.collapseChage();
    }
  },
  created() {
    this.$store.dispatch('STAFF_WEBSOCKET');
    this.getNoticeMission();
  },
};
</script>
<style scoped>
.header {
  position: relative;
  box-sizing: border-box;
  width: 100%;
  height: 70px;
  font-size: 22px;
  color: #fff;
}
.collapse-btn {
  float: left;
  padding: 0 21px;
  cursor: pointer;
  line-height: 70px;
}
.header .logo {
  float: left;
  width: 250px;
  line-height: 70px;
}
.header-right {
  float: right;
  padding-right: 10px;
}
.header-user-con {
  display: flex;
  height: 70px;
  align-items: center;
}
.btn-fullscreen {
  transform: rotate(45deg);
  margin-right: 5px;
  font-size: 24px;
}
.btn-bell,
.btn-fullscreen {
  position: relative;
  width: 30px;
  height: 30px;
  text-align: center;
  border-radius: 15px;
  cursor: pointer;
}
.btn-bell-badge {
  position: absolute;
  right: 0;
  top: -2px;
  width: 8px;
  height: 8px;
  border-radius: 4px;
  background: #f56c6c;
  color: #fff;
}
.btn-bell .el-icon-bell {
  color: #fff;
}
.user-name {
  margin-left: 10px;
}
.user-avator {
  margin-left: 20px;
}
.user-avator img {
  display: block;
  width: 40px;
  height: 40px;
  border-radius: 50%;
}
.el-dropdown-link {
  color: #fff;
  cursor: pointer;
}
.el-dropdown-menu__item {
  text-align: center;
}
.link-Jump {
  margin-left: 3px;
  border-width: 0px;
  color: rgb(54, 185, 243);
  font-size: 18px;
  background-color: rgba(255, 255, 255, 0.2);
}
.login {
  position: fixed;
  font-size: 24px;
  height: 200px;
  width: 200px;
  background-color: gold;
  border-radius: 0.25rem;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  z-index: 1000;
}
.over {
  position: fixed;
  width: 20%;
  height: 20%;
  opacity: 0.7;
  filter: alpha(opacity=70);
  top: 0;
  left: 0;
  z-index: 999;
  background-color: #111111;
}
</style>
